import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';
import ScrollToTop from '../components/ScrollToTop';

const LandingPage = lazy(() => import('../features/landing/LandingPage'));
const AboutPage = lazy(() => import('../features/about/AboutPage'));
const ValuesPage = lazy(() => import('../features/values/ValuesPage'));
const ActivitiesPage = lazy(
  () => import('../features/activities/ActivitiesPage')
);
const TestimonialsPage = lazy(
  () => import('../features/testimonials/TestimonialsPage')
);
const DonatePage = lazy(() => import('../features/donate/DonatePage'));
const ContactPage = lazy(() => import('../features/contact/ContactPage'));

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/sobre-nosotros" element={<AboutPage />} />
          <Route path="/valores" element={<ValuesPage />} />
          <Route path="/actividades" element={<ActivitiesPage />} />
          <Route path="/testimonios" element={<TestimonialsPage />} />
          <Route path="/donar" element={<DonatePage />} />
          <Route path="/contacto" element={<ContactPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRoutes;
